import './page-header.scss';

import * as gzPageHeaderDirective from './page-header.directive';
import gazelleCore from 'gazelle/src/core/core.module';

export default angular.module('gazelle.components.pageHeader', [
  'ngMaterial',
  'gazelle.components.go',
  gazelleCore,
])
  .directive(gzPageHeaderDirective.name, gzPageHeaderDirective.default)
  .name;



// WEBPACK FOOTER //
// ../~/@printos/gazelle/src/components/page-header/page-header.module.js